export const TABLE_PADDING_HORIZONTAL = 30;
export const TABLE_FILL_WIDTH_ID = "TABLE_FILL_WIDTH_ID";
